import { useMemo } from 'react'

export const PACK_OPTIMA_MIN_MONTHS = 72

export function hasPackOptima({
  initialEntry,
  activeNumber,
  maxPackGamaEntry,
}: {
  initialEntry: number
  activeNumber: number
  maxPackGamaEntry: number
}) {
  return (
    initialEntry <= maxPackGamaEntry && activeNumber >= PACK_OPTIMA_MIN_MONTHS
  )
}

// Custom hook to automatically calculate if has Pack Optima
export function useHasPackOptima(
  initialEntry: number,
  activeNumber: number,
  maxPackGamaEntry: number,
) {
  return useMemo(() => {
    return hasPackOptima({ initialEntry, activeNumber, maxPackGamaEntry })
  }, [initialEntry, activeNumber, maxPackGamaEntry])
}
